import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import {
    CommunityContext,
    PageContext,
} from '../../../../contexts/ContextCreator';

import Comment from '../Comment/Comment';

import './CommentList.scss';

// renders a list of comments and sub-comments for a given hash
const CommentList = ({
    hash,
    location,
    handleLinkClickMetricEmit,
    handlePostAndJoin,
    submitButtonText,
}) => {
    const { getContent, fetchMoreComments } = useContext(CommunityContext);
    const { wrapAuth } = useContext(PageContext);
    const content = getContent(hash);
    const [lastId, setLastId] = useState(content.lastId || null);
    const [expandMore, setExpandMore] = useState(false);

    // bail if no content found for provided hash
    if (!content) return null;

    // TODO: if no comments, show "no comments yet" text

    const comments = content.comments.map((c) => (
        <Comment
            key={c.hash}
            commentHash={c.hash}
            nestDepth={0}
            location={location}
            expandMore={expandMore}
            handleLinkClickMetricEmit={handleLinkClickMetricEmit}
            handlePostAndJoin={handlePostAndJoin}
            submitButtonText={submitButtonText}
        />
    ));

    const authMetrics = {
        login_trigger: 'comment',
        community_content_key: `${content.type}-${content.hash}`,
        community_on_comment: content.type === 'community-comment',
    };

    const isFeed = location === 'masterFeed' || location === 'groupFeed';
    const limit = isFeed ? 5 : null;

    // If there's a last id and there's at least one comment, render the button
    // If there's a zero commentCount, they are all deleted
    const seeMoreCommentsButton =
        lastId !== -1 && !!content.commentCount
            ? wrapAuth(
                  `commentList-${hash}`,
                  <div className="component-Community-CommentBox-buttonContainer">
                      <button
                          onClick={async () => {
                              const lastCommentId = await fetchMoreComments(
                                  content.type,
                                  hash,
                                  null,
                                  limit,
                                  lastId,
                                  isFeed
                              );
                              setLastId(lastCommentId);
                              setExpandMore(true);
                              handleLinkClickMetricEmit(
                                  'see-more-comments-click'
                              );
                          }}
                          className="component-Community-CommentBox-SeeMoreCommentsLink"
                          type="button"
                      >
                          See more comments
                      </button>
                  </div>,
                  authMetrics
              )
            : null;

    return (
        <div className="component-Community-CommentBox-CommentList">
            {comments}
            {seeMoreCommentsButton}
        </div>
    );
};

CommentList.propTypes = {
    hash: PropTypes.string.isRequired,
    location: PropTypes.oneOf([
        'masterFeed',
        'miniFeed',
        'groupFeed',
        'singleContent',
    ]).isRequired,
    handleLinkClickMetricEmit: PropTypes.func,
    handlePostAndJoin: PropTypes.func,
    submitButtonText: PropTypes.string,
};

CommentList.defaultProps = {
    handleLinkClickMetricEmit: () => {},
    handlePostAndJoin: null,
    submitButtonText: 'Post',
};

CommentList.displayName = 'CommentList';

export default CommentList;
